import HistoryListItem from '../../components/history/HistoryList/HistoryListItem';
import HistoryListHeader from '../../components/history/HistoryList/HistoryListHeader';
import { Box } from '@mui/material';
import { useTitle } from 'react-use';
import { t } from '@lingui/core/macro';

const HistoryListPage = () => {
  useTitle(t`History`);

  return (
    <Box data-testid="History-page">
      <HistoryListHeader />
      <HistoryListItem />
    </Box>
  );
};

export default HistoryListPage;
